// @flow
import * as React from 'react';
import { useState } from 'react';
import { Box, Divider, Stack, Tab as MuiTab, Tabs, Typography } from '@mui/material';
import { AddNoteButton, AddManagerNoteButton } from './ui/add-note-button';
import { useClient } from '../../hooks/client-context';
import { NoteItem } from './ui/note-item';
import _ from 'lodash';


export const Notes = () => {
  const client = useClient();
  const [tab, setTab] = useState(0);

  const allNotes = _.orderBy(client.notes, 'updatedAt', 'desc');
  const agentNotes = allNotes.filter(n => !n.isManagerNote);
  const managerNotes = allNotes.filter(n => n.isManagerNote);

  const visibleNotes = tab === 0 ? allNotes : tab === 1 ? agentNotes : managerNotes;

  return (
    <Stack gap={2}>
      <Stack gap={2} direction={'row'} alignItems={'center'} flex={1}>
        <Typography variant={'subtitle1'} flex={1}>Notes</Typography>
        <AddManagerNoteButton />
        <AddNoteButton />
      </Stack>

      <Tabs value={tab} onChange={(_, v) => setTab(v)}>
        <MuiTab label={`All notes${client.notes?.length ? ` (${client.notes.length})` : ''}`} />
        <MuiTab label={`Agent notes${agentNotes.length ? ` (${agentNotes.length})` : ''}`} />
        <MuiTab label={`Manager notes${managerNotes.length ? ` (${managerNotes.length})` : ''}`} />
      </Tabs>

      <Stack gap={3}>
        {visibleNotes.map((note, i, array) => (
          <React.Fragment key={note.id}>
            <NoteItem note={note} />
            {i < array.length - 1 && <Divider />}
          </React.Fragment>
        ))}
        {!visibleNotes.length && (
          <Box sx={{height: 150, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Typography color={'text.secondary'} variant={'body2'}>No notes added</Typography>
          </Box>
        )}
      </Stack>
    </Stack>
  );
}
